// Api.js
import axios from "axios";
import { processAlerts, processOneAlert,uuidv4 } from "/core/services/alerts/alerts";
import { ajaxIsCalling } from '/core/stores/ajaxLoader.js';

const getApiChunk = () => {
    return window.globalSiteData.api_chunk;
};

const technicalError = (e) => {    
    return {
        success: false,
        messages: [],
        data: null
    };
}

// Create a instance of axios to use the same base url.
const axiosAPI = axios.create({
  baseURL : "/api/"+getApiChunk()+"/v1/"
});

// implement a method to execute all the request from here.
const apiRequest = (method, url, request) => {
    const headers = {
        authorization: ""
    };

    ajaxIsCalling.set(true);

    //using the axios instance to perform the request that received from each http method
    return axiosAPI({
        method,
        url,
        data: request,
        headers
      }).then(res => {
        ajaxIsCalling.set(false);
        res = Promise.resolve(res.data);
        processAlerts(res);
        return res;
      })
      .catch(err => {
          ajaxIsCalling.set(false);
          let alert = {
              uuid: uuidv4(),
              type: 'danger',
              timed: true,
              msg: 'Technical Issue: '+err.message
          };
          processOneAlert(alert);

          return Promise.reject(err);
      });
};

// function to execute the http get request
const get = (url, request) => apiRequest("get",url,request);

// function to execute the http delete request
const deleteRequest = (url, request) =>  apiRequest("delete", url, request);

// function to execute the http post request
const post = (url, request) => apiRequest("post", url, request);

// function to execute the http put request
const put = (url, request) => apiRequest("put", url, request);

// function to execute the http path request
const patch = (url, request) =>  apiRequest("patch", url, request);

// expose your method to other services or actions
const API ={
    get,
    delete: deleteRequest,
    post,
    put,
    patch,
    getApiChunk,
    technicalError
};
export default API;
